/**
 * notificationStream — thin factory around the shared NotificationSSEClient.
 *
 * Shared transport: @levelup/central-notifications (SSE parser, exponential
 * backoff, heartbeat tracking). App-local: CENTRAL_URL config + token/workspace
 * supplied via .connect().
 *
 * The factory creates a configured but unconnected client; the lifecycle
 * (connect/disconnect, handler registration) is owned by NotificationProvider
 * so we get exactly ONE notification SSE connection per session.
 *
 * Bearer-only. No cookies. No proxy.
 */

import { NotificationSSEClient } from '@levelup/central-notifications';
import { CENTRAL_URL } from '../config/centralAuth';

export function createNotificationStreamClient(): NotificationSSEClient {
  return new NotificationSSEClient({ centralUrl: CENTRAL_URL });
}
